import { render, staticRenderFns } from "./CrudContainer.vue?vue&type=template&id=3b7a3972&"
import script from "./CrudContainer.vue?vue&type=script&lang=js&"
export * from "./CrudContainer.vue?vue&type=script&lang=js&"
import style0 from "./CrudContainer.vue?vue&type=style&index=0&id=3b7a3972&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports